<template>
  <div>
    <v-data-table height="77vh" :headers="headers" :items="items" :loading="loading.data" :items-per-page="100"
                  fixed-header
                  :options.sync="params.options" :server-items-length="params.total"
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true, itemsPerPageOptions: [100, 200, 500]}">
      <template v-slot:top>
        <v-toolbar flat>
          <template v-if="selected && selected.type && selected.type !== 'market'">
            <span class="mr-3">延迟索评天数设置: </span>
            <v-text-field v-model="setting.minRequestDaysLater" :loading="loading.setting"
                          hide-details class="shrink" style="width: 50px" suffix="天"/>
            <span class="mx-3">-</span>
            <v-text-field v-model="setting.maxRequestDaysLater" :loading="loading.setting"
                          hide-details class="shrink" style="width: 50px" suffix="天"/>
            <span class="mx-3">每日索评时间段(当地): </span>
            <v-text-field v-model="setting.startRequestTime" :loading="loading.setting"
                          type="time" hide-details class="shrink"/>
            <span class="mx-3">-</span>
            <v-text-field v-model="setting.endRequestTime" :loading="loading.setting"
                          type="time" hide-details class="shrink"/>
            <v-btn icon :loading="loading.setting" @click="saveSetting">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
          </template>
          <v-spacer/>
          <span class="mr-3">待索评: {{ count }}</span>
          <template v-if="selected && selected.type === 'sku'">
            <v-switch v-model="status" :loading="loading.status" @change="changeStatus" hide-details/>
            启用自动索评
          </template>
          <v-btn icon @click="filterDialog = true">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <v-btn icon @click="getData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.storeName="{ item }">
        <div>{{ item.storeName }}</div>
        <div>{{ item.marketName }}</div>
      </template>
      <template v-slot:item.sku="{ item }">
        <div>{{ item.asin }}</div>
        <div>{{ item.sku }}</div>
      </template>
      <template v-slot:item.status="{ item }">
        <span v-if="item.status === 1" class="success--text">成功</span>
        <span v-else-if="item.status === 2" class="success--text">已索评</span>
        <span v-else-if="item.status === 3" class="warning--text">已退款<br/>{{ item.remark | dateFormat }}</span>
        <span v-else-if="item.status === 0" class="warning--text">时辰未到</span>
        <span v-else class="error--text">{{ item.remark }}</span>
      </template>
      <template v-slot:item.purchaseDate="{item}">
        {{ item.purchaseDate | dateFormat('MM-dd HH:mm:ss') }}
      </template>
      <template v-slot:item.updateTime="{item}">
        {{ item.updateTime | dateFormat('MM-dd HH:mm:ss') }}
      </template>
    </v-data-table>
    <request-filter-dialog v-model="filterDialog" :filters="params.filters" @reload="getData"/>
  </div>
</template>

<script>
import RequestFilterDialog from "@/page/Request/RequestFilterDialog";
export default {
  name: "RequestRecord",
  components: {RequestFilterDialog},
  props: {
    selected: Object
  },
  computed: {},
  data() {
    return {
      loading: {
        data: false,
        setting: false,
        status: false,
        count: false
      },
      filterDialog: false,
      headers: [
        {text: "店铺", align: "center", sortable: false, value: "storeName"},
        {text: "商品", align: "center", sortable: false, value: "sku"},
        {text: "亚马逊订单编号", align: "center", sortable: false, value: "amazonOrderId"},
        {text: "索评状态", align: "center", sortable: false, value: "status"},
        {text: "订单时间", align: "left", sortable: true, value: "purchaseDate"},
        {text: "索评时间", align: "left", sortable: true, value: "updateTime"},
      ],
      items: [],
      setting: {
        minRequestDaysLater: null,
        maxRequestDaysLater: null,
        startRequestTime: null,
        endRequestTime: null
      },
      status: false,
      count: null,
      params: {
        options: {
          sortBy: ["updateTime"],
          sortDesc: [true]
        },
        filters: {
          marketCode: null,
          storeName: null,
          sku: null,
          status: null,
          amazonOrderId: null,
          startPurchaseTime: null,
          endPurchaseTime: null,
          startRequestTime: null,
          endRequestTime: null,
        },
        total: 0
      }
    }
  },
  methods: {
    getData() {
      this.items = []

      this.loading.data = true

      this.$axios.post('/request/records', this.params).then(res => {
        this.items = res.data.list
        this.params.total = res.data.total
        this.loading.data = false
      })
    },
    countOrdersForRequest() {
      this.count = null
      this.loading.data = true

      this.$axios.get('/request/count', {params: this.params.filters}).then(res => {
        this.count = res.data
        this.loading.data = false
      })
    },
    getSetting() {
      if (this.selected && this.selected.marketCode) {
        this.loading.setting = true
        this.$axios.get('/store/setting', {
          params: {
            marketCode: this.selected.marketCode,
            storeName: this.selected.storeName
          }
        }).then(res => {
          if (res.data) {
            this.setting = res.data
          } else {
            this.setting = {
              minRequestDaysLater: null,
              maxRequestDaysLater: null,
              startRequestTime: null,
              endRequestTime: null
            }
          }
          this.loading.setting = false
          // console.log('获得的店铺配置信息', this.setting)
        })
      }
    },
    saveSetting() {
      if (!this.setting.minRequestDaysLater || !this.setting.maxRequestDaysLater
          || !this.setting.startRequestTime || !this.setting.endRequestTime) {
        this.$bus.$emit('msg', '请完整填写索评的配置信息')
        return
      }

      if (this.setting.minRequestDaysLater >= this.setting.maxRequestDaysLater) {
        this.$bus.$emit('msg', '最小索评天数必须小于最大索评天数')
        return
      }

      if (this.setting.startRequestTime >= this.setting.endRequestTime) {
        this.$bus.$emit('msg', '开始索评时间必须小于结束索评时间')
        return
      }

      this.loading.setting = true
      this.$axios.patch('/store/setting', {
        marketCode: this.selected.marketCode,
        name: this.selected.storeName,
        minRequestDaysLater: this.setting.minRequestDaysLater,
        maxRequestDaysLater: this.setting.maxRequestDaysLater,
        startRequestTime: this.setting.startRequestTime,
        endRequestTime: this.setting.endRequestTime
      }).then(() => {
        this.loading.setting = false
      })
    },
    getStatus() {
      this.loading.status = true
      this.$axios.get('/request/plan', {
        params: {
          marketCode: this.selected.marketCode,
          storeName: this.selected.storeName,
          sku: this.selected.name
        }
      }).then(res => {
        this.status = res && res.data
        this.loading.status = false
      })
    },
    changeStatus() {
      if (this.status && (!this.setting || !this.setting.minRequestDaysLater || !this.setting.maxRequestDaysLater
          || !this.setting.startRequestTime || !this.setting.endRequestTime)) {
        this.$bus.$emit('msg', '请先设置店铺的索评时间段')
        this.status = false
        return
      }
      this.loading.status = true
      let params = new URLSearchParams()
      params.append('marketCode', this.selected.marketCode)
      params.append('storeName', this.selected.storeName)
      params.append('sku', this.selected.name)
      params.append('status', this.status ? 'true' : 'false')

      this.$axios.patch('/request/plan', params).then(() => {
        this.loading.status = false
      })
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    'selected': {
      deep: true,
      handler() {
        console.log('选中的节点: ', this.selected)
        this.params.filters.marketCode = null
        this.params.filters.storeName = null
        this.params.filters.sku = null

        if (this.selected.type === 'market') {
          this.params.filters.marketCode = this.selected.marketCode
        } else if (this.selected.type === 'store') {
          this.params.filters.marketCode = this.selected.marketCode
          this.params.filters.storeName = this.selected.storeName
        } else if (this.selected.type === 'sku') {
          this.params.filters.marketCode = this.selected.marketCode
          this.params.filters.storeName = this.selected.storeName
          this.params.filters.sku = this.selected.name
        }
        this.getSetting()
        this.getStatus()
        this.getData()
        this.countOrdersForRequest()
      }
    },
    'params.options': {
      deep: true,
      handler() {
        this.getData()
      }
    }
  }
}
</script>

<style scoped>

</style>